module.exports = __webpack_public_path__ + "static/media/broker-team-cropped.2aa091be.jpg";